<template>
  <v-container class="text-center pr-0 pl-0" fluid>
    <v-card class="elevation-10" dense :disabled="dialogLoader">
      <v-card-title class="justify-center">Meus dados</v-card-title>
      <v-card-text>
        <v-row>

          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-0 pb-0">
            <v-text-field
                v-model="nome"
                label="Nome"
                prepend-icon="mdi-numeric-1-box-multiple"
                maxlength="20"
                :error-messages="$v.nome.$invalid ? ['Campo obrigatório'] : []"
                clearable
                outlined
              ></v-text-field>
          </v-col>

          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-0 pb-0">
            <v-text-field
                :disabled="$v.nome.$invalid"
                v-model="sobrenome"
                label="Sobrenome"
                prepend-icon="mdi-numeric-2-box-multiple"
                maxlength="20"
                :error-messages="$v.sobrenome.$invalid ? ['Campo orbigatório'] : []"
                clearable
                outlined
              ></v-text-field>
          </v-col>

          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-0 pb-0">
            <v-text-field @keyup="checkEmail()" @change="checkEmail()" 
                @click:clear="checkEmail()"
                :disabled="$v.sobrenome.$invalid"   
                v-model="fieldn"
                label="Email"
                prepend-icon="mdi-email"
                maxlength="100"
                :error-messages="$v.fieldn.$invalid ? ['Digite um email válido'] : []"
                clearable
                outlined
              ></v-text-field>
          </v-col>

          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-0 pb-0">
            <v-text-field
                :disabled="$v.fieldn.$invalid"
                v-model="fieldp1"
                label="Senha"
                prepend-icon="mdi-lock"
                maxlength="12"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                outlined
                counter
                @click:append="show1 = !show1"
                clearable
              ></v-text-field>
          </v-col>

          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-0 pb-0">
            <v-text-field
                :disabled="$v.fieldn.$invalid"
                v-model="fieldp2"
                :error-messages="$v.fieldp2.$invalid ? ['Confirmação diferente da senha'] : []"
                label="Confirme a senha"
                prepend-icon="mdi-lock"
                maxlength="12"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                outlined
                counter
                @click:append="show2 = !show2"
                clearable
              ></v-text-field>
          </v-col>
          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-4 pb-0" v-if="resultMessage != null && resultMessage != ''">
            <span class="my-login-error text-body-1 font-weight-black">{{resultMessage}}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn :disabled="emailExists || $v.fieldp2.$invalid || dialogLoader" x-large color="primary" class="mb-2" width="100%" @click="salvar()">
          vamos lá!
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Aguarde...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>

<script>

import { required, minLength, email, sameAs} from 'vuelidate/lib/validators';
import HOST from '../ws';


export default {
  props: {
    source: String
  },
  data: () => ({

    myHost : HOST.HOST,

    //novo usuario:
    nome : '',
    sobrenome : '',
    fieldn : '',
    fieldp1 : '',
    fieldp2 : '',
    show1 : false,
    show2 : false,
    resultMessage : '',

    dialogLoader : false,

    emailExists : false,

  }),
  methods : {

    checkEmail(){

      if(!this.$v.fieldn.$invalid){
        this.resultMessage = null;
        this.emailExists = false;
        this.axios({
          method: 'post',
          url : this.myHost + '/user/checkemail', 
          headers: {
              'Content-Type' : 'application/json'},           
              data : this.fieldn
        }).then((response) => {
          console.log('user by email : ' + response.status);
          if(response.status == 200){ // retornou dados, o email existe
            this.resultMessage = 'Este e-mail já está cadastrado';
            this.emailExists = true;
          }
        });
      }
    },

    salvar() {

      this.dialogLoader = true;

      let newUser = {
        name: this.nome,
        lastName: this.sobrenome,
        email: this.fieldn,
        password: this.fieldp1
      }

      console.log('novo usuario : \n' + JSON.stringify(newUser));

      this.axios({
        method: 'post',
        url: this.myHost + '/user/createaccount',
        headers: { 'Content-Type': 'application/json' },
        data: newUser
      }).then((response) => {

        if (response.status == 200) { //cadastro ok, carregamos o usuario na sessão:


          const formData = new FormData();
          formData.append('grant_type', 'password');
          formData.append('username', this.fieldn);
          formData.append('password', this.fieldp1);

          this.axios.post(this.myHost + '/oauth/token', formData,
            {
              auth: {
                username: 'client',
                password: '123'
              }
            })
            .then((response2) => {

              //granvando token:
              this.$store.commit('addToken', response2.data.access_token);

              //login ok, carreagamos usuario na sessao:
              this.axios({
                method: 'post',
                url: this.myHost + '/user/userbyemail',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${this.$store.state.currentToken}`
                },
                data: this.fieldn
              }).then((response3) => {
                this.$store.commit('addUserLogged', response3.data);
              });

              this.dialogLoader = false;
              this.$router.push("noticias");
            })
            .catch((error) => {
              console.log(error.message);
              this.dialogLoader = false;
            });

        }
      });
    }
  },
  validations: {
    fieldn: {
      required,
      email,
      minLength: minLength(8),

    },
    fieldp1: {
      required,
      minLength: minLength(4),
    },
    fieldp2: {
      required,
      minLength: minLength(4),
      sameAsPassword: sameAs('fieldp1')
    },
    nome: {
      required,
      minLength: minLength(2)
    },
    sobrenome: {
      required,
      minLength: minLength(2)
    }
  },
};
</script>

<style>

.my-login-error{
  color: #F06B34;
}

</style>